import React from 'react'
import { Separator, AuthSubtitle, AuthTitleWrapper } from 'pages/Authentication/components/AuthTitle/styles'

interface IProps {
  title: React.ReactNode,
  subtitle?: React.ReactNode,
  small?: boolean,
  hideSeparatorMobile?: boolean,
  color?: string
}

const AuthTitle = (props: IProps) =>
  <AuthTitleWrapper small={props.small}>
    <h2>{props.title}</h2>

    { props.subtitle &&
      <AuthSubtitle>{props.subtitle}</AuthSubtitle>
    }

    <Separator
      hideOnMobile={props.hideSeparatorMobile}
      color={props.color}
    />
  </AuthTitleWrapper>

export default AuthTitle
